import React from 'react';

export function useAfterTransition(transitioningElement, afterTransition) {
  React.useEffect(() => {
    transitioningElement.current &&
      transitioningElement.current.addEventListener(
        'transitionend',
        afterTransition,
      );
    return () => {
      transitioningElement.current &&
        transitioningElement.current.removeEventListener(
          'transitionend',
          afterTransition,
        );
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [afterTransition]);
}
